import { Component, Input } from '@angular/core';

@Component({
    selector: 'atx-rate',
    template: `<nz-rate [ngModel]="value" nzAllowHalf></nz-rate>
`,
    styles: [``],
})

export class AtxRateComponent {
    @Input() public readonly value: number;
}
